const COMMON_PERMISSIONS = [
  'dashboard.view',
  'billing.view',
  'billing.manage',
  'services.view',
  'services.manage',
  'products.view',
  'products.manage',
  'staff.view',
  'staff.manage',
  'expenses.view',
  'expenses.manage',
  'reports.view',
  'memberships.view',
  'memberships.manage',
  'leads.view',
  'leads.manage',
  'marketing.view',
  'marketing.manage',
  'bill_history.view',
  'settings.view',
];

export const SALON_ROLE_DEFINITIONS = {
  owner: {
    label: 'Owner',
    permissions: ['*'],
  },
  manager: {
    label: 'Manager',
    permissions: [...COMMON_PERMISSIONS, 'users.view'],
  },
  cashier: {
    label: 'Cashier',
    permissions: COMMON_PERMISSIONS.slice(),
  },
  receptionist: {
    label: 'Receptionist',
    permissions: COMMON_PERMISSIONS.slice(),
  },
  marketing: {
    label: 'Marketing',
    permissions: COMMON_PERMISSIONS.slice(),
  },
  staff: {
    label: 'Staff',
    permissions: COMMON_PERMISSIONS.slice(),
  },
};

export function filterRestrictedPermissions(permissions, restrictedFeatures, role) {
  if (role !== 'manager' || !Array.isArray(restrictedFeatures) || !restrictedFeatures.length) {
    return permissions;
  }
  
  let nextPerms = [...permissions];
  
  if (restrictedFeatures.includes('inventory')) {
    nextPerms = nextPerms.filter(p => !['products.view', 'products.manage'].includes(p));
  }
  if (restrictedFeatures.includes('billing')) {
    nextPerms = nextPerms.filter(p => !['billing.view', 'billing.manage', 'bill_history.view'].includes(p));
  }
  if (restrictedFeatures.includes('employee_management')) {
    nextPerms = nextPerms.filter(p => !['staff.view', 'staff.manage'].includes(p));
  }
  if (restrictedFeatures.includes('user_management')) {
    nextPerms = nextPerms.filter(p => !['users.view'].includes(p));
  }
  if (restrictedFeatures.includes('settings')) {
    nextPerms = nextPerms.filter(p => !['settings.view'].includes(p));
  }
  if (restrictedFeatures.includes('analytics')) {
    nextPerms = nextPerms.filter(p => !['marketing.view', 'marketing.manage', 'leads.view', 'leads.manage'].includes(p));
  }

  return nextPerms;
}

export function resolveSalonPermissions(user) {
  if (!user) return [];
  if (user.isOwner) return ['*'];
  
  let permissions = [];
  if (Array.isArray(user.permissions) && user.permissions.length) {
    permissions = user.permissions;
  } else {
    permissions = (SALON_ROLE_DEFINITIONS[user.role] || SALON_ROLE_DEFINITIONS.staff).permissions.slice();
  }
  
  if (user.role === 'manager' && Array.isArray(user.restrictedFeatures)) {
    permissions = filterRestrictedPermissions(permissions, user.restrictedFeatures, user.role);
  }
  
  return permissions;
}

export function hasSalonPermission(userOrPermissions, permission) {
  const permissions = Array.isArray(userOrPermissions)
    ? userOrPermissions
    : resolveSalonPermissions(userOrPermissions);
  return permissions.includes('*') || permissions.includes(permission);
}
